var map = {
	"./en": [
		"e312",
		"en"
	],
	"./en.json": [
		"e312",
		"en"
	],
	"./ru": [
		"3a06",
		"ru"
	],
	"./ru.json": [
		"3a06",
		"ru"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "5892";
module.exports = webpackAsyncContext;